import { ACCESS_MODES, persistAccessMode } from "./accessMode";

export const SAMPLE_ACCESS_KEY = "venaqqi_sample_access_v1";
export const SAMPLE_GUEST_USAGE_KEY = "venaqqi_guest_recommendation_usage_v1";
export const SAMPLE_GUEST_CONVERSATION_KEY = "venaqqi_don_d_conversation_v1";
export const SAMPLE_UI_STATE_KEY = "venaqqi_ui_state_v1";
export const SAMPLE_DURATION_MS = 3 * 60 * 60 * 1000;

// Capability link for the 22-Sep-2026 interview follow-up.
// Possession of this token is the authorization; no email or account verification is required.
export const SAMPLE_ACCESS_TOKEN = "fernanda-220926-3h-8P4Q7M2X9K";

export const SAMPLE_INVITEES = Object.freeze([
  { id: "fernanda", name: "Fernanda", organization: "Entrevista 22-Sep-2026" },
]);

const localStore = () => typeof window !== "undefined" ? window.localStorage : undefined;
const sessionStore = () => typeof window !== "undefined" ? window.sessionStorage : undefined;
const browserLocation = () => typeof window !== "undefined" ? window.location : undefined;
const safeParse = value => {
  try { return JSON.parse(value || "null"); } catch { return null; }
};

const inviteeFor = value => SAMPLE_INVITEES.find(invitee => invitee.id === value || invitee.name === value) || null;

export const isSampleInviteLink = (location = browserLocation()) => {
  if (!location) return false;
  const params = new URLSearchParams(location.search || "");
  return String(params.get("sample") || "").trim() === SAMPLE_ACCESS_TOKEN;
};

export const formatSampleCountdown = milliseconds => {
  const totalSeconds = Math.max(0, Math.floor(Number(milliseconds || 0) / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds].map(value => String(value).padStart(2, "0")).join(":");
};

export const readSampleSession = (storage = localStore(), now = Date.now()) => {
  if (!storage) return null;
  const parsed = safeParse(storage.getItem(SAMPLE_ACCESS_KEY));
  const invitee = inviteeFor(parsed?.inviteeId || parsed?.inviteeName);
  const expiresAt = Number(parsed?.expiresAt);
  if (!invitee || !expiresAt || now >= expiresAt) return null;
  return {
    version: 2,
    inviteeId: invitee.id,
    inviteeName: invitee.name,
    organization: invitee.organization,
    startedAt: Number(parsed?.startedAt) || now,
    expiresAt,
  };
};

export const hasActiveSampleSession = (storage = localStore(), now = Date.now()) => Boolean(readSampleSession(storage, now));

const clearSampleResidue = (storage = localStore(), browserSessionStorage = sessionStore()) => {
  try {
    storage?.removeItem(SAMPLE_GUEST_USAGE_KEY);
    storage?.removeItem(SAMPLE_GUEST_CONVERSATION_KEY);
    browserSessionStorage?.removeItem(SAMPLE_UI_STATE_KEY);
  } catch { /* storage unavailable */ }
};

export const startSampleSession = (inviteeValue = "fernanda", storage = localStore(), now = Date.now(), browserSessionStorage = sessionStore()) => {
  if (!storage) throw new Error("No se pudo iniciar el acceso temporal.");
  const invitee = inviteeFor(inviteeValue);
  if (!invitee) throw new Error("Invitado Sample no válido.");
  const sampleSession = {
    version: 2,
    inviteeId: invitee.id,
    inviteeName: invitee.name,
    organization: invitee.organization,
    startedAt: now,
    expiresAt: now + SAMPLE_DURATION_MS,
  };
  clearSampleResidue(storage, browserSessionStorage);
  storage.setItem(SAMPLE_ACCESS_KEY, JSON.stringify(sampleSession));
  persistAccessMode(ACCESS_MODES.GUEST, storage);
  return sampleSession;
};

export const clearSampleSession = (storage = localStore(), browserSessionStorage = sessionStore()) => {
  if (!storage) return;
  try { storage.removeItem(SAMPLE_ACCESS_KEY); } catch { /* storage unavailable */ }
  persistAccessMode(ACCESS_MODES.PENDING, storage);
  clearSampleResidue(storage, browserSessionStorage);
};

export const expireStaleSampleSession = (storage = localStore(), now = Date.now(), browserSessionStorage = sessionStore()) => {
  if (!storage) return false;
  const parsed = safeParse(storage.getItem(SAMPLE_ACCESS_KEY));
  if (!parsed) return false;
  if (readSampleSession(storage, now)) return false;
  clearSampleSession(storage, browserSessionStorage);
  return true;
};
